import React from 'react';

import '../Tutorial.css';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T70PlaySpellCard() {

    /*
  useEffect(() => {
    UserService.sendEvent('PlaySpellCard70');
  }, []); */

  const text = 'Play the \'Fire Bolt\' card. Tap, click, or drag it onto the battlefield.';

    return (
        <div>


            <div className='PlayCard50Right'></div>

            <TutorialGirl position={'Right'}/>
            <div className='tutorialContainer tutorialTopContainerShoRes35'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>
    );
}

export default T70PlaySpellCard;
